var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#E03A3E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.9,93.7c-28.8-30.8-70.7-48.4-115-48.4c-3.8,0-7.6,0.1-11.3,0.5c-71.5,4.8-106,55.7-109.6,61.3 c-5.4,6.7-50.7,68-20.3,152.6l0.6,1.8C57.6,262.4,87.2,353,193,353l0,0c5.6,0,11.5-0.3,17.4-0.8c79.1-6.9,137.8-65.3,142.8-141.9 C356.3,166.2,342,124.8,312.9,93.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.4,100.6c-29.7-31.7-73.5-48-118.3-44.9C116,60.5,84.4,113.4,84.4,113.4s56.4,17.1,64.1,19.5 c5.4,1.6,40.4,10.4,56.3,19c3.3,1.8,6.5,5.5,9.7,8.8c2.4,2.5,4.6,4.9,6.9,6.8c4.2,3.4,8.2,6.3,12.2,9.2 c9.7,7.1,18.2,13.1,22.2,22.4c3.4,8,3.5,16.4,0.5,24.1c-2.7,6.7-8,12.8-14.4,17c0.7-3.4,1.5-8.3-3.1-11.3 c-2.1-1.3-12.6-3.8-19.7-4.6c-3.4-0.3-41.5-2.1-94.3,26.4c15.8-21.2,27.2-24.7,27.2-24.7c-0.5-2.5-85.5,31.9-85.5,31.9 s29.4,94.1,142.8,84.1c73.9-6.5,128.9-60.6,133.7-132.7C345.8,168.2,332.4,129.5,305.4,100.6 M281.8,233.8 c10.7-23.6,5.4-49.2-12.8-69.5c-5-5.6-11.3-9.5-17.3-13.1c-3.9-2.4-8-4.9-11.6-7.9c-1.7-1.4-3.1-3.3-4.6-5.2 c-1.8-2.5-3.9-5.4-6.9-7.4c-16.7-12.2-36.5-16.5-55.9-22.2c-9.2-2.7-18.1-4.7-26.5-7.7c10.5-7.2,23.8-12,38.4-13.3 c4.6-0.5,9.1-0.7,13.7-0.7c43.1,0,80.5,21.6,100.5,58c19.9,36.3,18.7,80.4-3.4,115.2c-22.7,35.7-62.9,54.6-108.4,50.8 c-27.2-2.2-56.3-16.6-65.2-32c5.5-3.4,55.2-29.7,89.3-19.1c9.7,0-5.8,23.7-5.8,23.7S261.6,278.4,281.8,233.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.7,162.3c-18.2,0.7-35.1-21.3-49.1-6.8c2.7,0.7,8.3-1.4,9.1,1.1C150.5,185,197.3,192.4,197.7,162.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtl);
export default __webpack_public_path__ + "static/media/ATL.bb9676f0b9f16c8c173ae2d8f67c9dfe.svg";
export { ForwardRef as ReactComponent };